import {
    CardHolderRfidCell,
    StatusRfidCell,
} from "layouts/rfid/rfid-dashboard/cells.tsx"
import { RfidNumberCell } from "layouts/rfid/rfid-dashboard/rfid-number-cell.tsx"
import { IFormRfidFilter } from "layouts/rfid/rfid-dashboard/filter"
import {
    rfidNumberComparator,
    cardHolderRfidComparator,
    statusRfidComparator,
} from "layouts/rfid/utils/functions"
import { RfidsColumn, RfidsTableColumnsType } from "types/rfid"
import { RuleType } from "layouts/charging-rules/interface/Rules.ts"
import CreditCardIcon from "@mui/icons-material/CreditCard"
import PersonIcon from "@mui/icons-material/Person"
import CarUtilityIcon from "assets/svg/car-utility.svg?react"
import DisplayTable from "assets/svg/display-table.svg?react"
import DisplayCard from "assets/svg/display-card.svg?react"

export const rfidsColumns: RfidsTableColumnsType = {
    rfid_number: {
        title: "Numéro de carte",
        width: "25%",
        comparatorFn: rfidNumberComparator,
        cellComponent: RfidNumberCell,
        isSortable: true,
    },
    driver: {
        title: "Conducteur/Véhicule",
        width: "40%",
        comparatorFn: cardHolderRfidComparator,
        cellComponent: CardHolderRfidCell,
        isSortable: true,
    },
    status: {
        title: "Statut",
        width: "25%",
        comparatorFn: statusRfidComparator,
        cellComponent: StatusRfidCell,
        isSortable: true,
    },
}

export const defaultFilterValuesRfids: IFormRfidFilter = {
    cardHolder: "",
    rfidNumber: "",
    status: "all",
    type: "ALL",
}

export const noRulesApplied = {
    rules: {
        [RuleType.DOWBlocked]: null,
        [RuleType.HoursBlocked]: null,
        [RuleType.MaxRechargeDurationOptions]: null,
        [RuleType.MaxRechargeEnergyOptions]: null,
    },
}

export const footerStyle = {
    position: "fixed",
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    bgcolor: "white",
    paddingTop: "15px",
    paddingBottom: "12px",
    height: "60px",
    gap: "10px",
    boxShadow: "0px 0px 50px 0px rgba(0, 0, 0, 0.05)",
    borderTop: "1px solid #F2F4F8",
}

export const buttonDefs = [
    {
        id: "ALL",
        label: "Toutes les cartes",
        icon: CreditCardIcon,
        dataCy: "page__rfid--all",
    },
    {
        id: "VEHICLE",
        label: "Cartes véhicule",
        icon: CarUtilityIcon,
        dataCy: "page__rfid--vehicle",
    },
    {
        id: "DRIVER",
        label: "Cartes conducteur",
        icon: PersonIcon,
        dataCy: "page__rfid--driver",
    },
] as const

export const tableType = [
    { id: "card", icon: DisplayCard, dataCy: "page__rfid--card" },
    { id: "table", icon: DisplayTable, dataCy: "page__rfid--list" },
] as const

export enum RfidStatus {
    Active = "enabled",
    Deactivate = "suspended",
    ToBeActivate = "disabled",
}

export const rfidColumnsOrder: RfidsColumn[] = [
    "rfid_number",
    "driver",
    "status",
]
